<template>
  <div>
    <el-table
      :data="models"
      :border="border"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      @sort-change="handleSort"
    >
      <el-table-column type="index" width="50" label="#" :index="index"></el-table-column>
      <el-table-column prop="id" label="ID" width="70" sortable="custom"></el-table-column>
      <el-table-column label="使用位置" width="180">
        <template v-slot="column">
          <div v-for="(item, key) in column.row.refs" :key="key">
            <span>L{{item.level}}</span>-<span>{{item.num}} </span>
            <span>{{item.type}}:</span><span>{{item.tid}} </span>
            <span>{{item.text}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="text" label="句子">
        <template #header="column">
          <el-input v-model="search" size="medium" placeholder="输入关键字或ID搜索句子" style="width:200px;" clearable/>
        </template>
      </el-table-column>
      <el-table-column fixed="right" width="100" align="right">
        <template #default="column">
          <slot name="operate" :row="column.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: 'SentenceInlineList',
  components: { },
  props: {
    border: Boolean,
    selection: [Array, Number]
  },
  data () {
    return {
      search: '',
      models: [],
      total: 0,
      index: 1,
      currentPage: 1,
      pageSize: 5,
      sort: '-id',
    }
  },
  watch: {
    search() {
      this.fetchData()
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      let params = {
        "filter[and][0][status]": 1,
        page: this.currentPage,
        'per-page': this.pageSize,
        sort: this.sort
      }
      if (this.search) {
        Object.assign(params, {
          // "filter[and][0][level]": this.$refs.search.level || null,
          // "filter[and][0][num]": this.$refs.search.num || null,
          "filter[and][1][or][0][text][regexp]": this.normalRegexpSearch(this.search),
          "filter[and][1][or][1][pinyin][like]": this.search || null,
          "filter[and][1][or][2][id]": /^\d+$/.test(this.search) ? this.search : null,
        })
      }
      this.$http.get(this.$urls.sentence_list, { params }).then(res => {
        this.total = Number.parseInt(res.headers['x-pagination-total-count'])
        this.currentPage = Number.parseInt(res.headers['x-pagination-current-page'])
        this.models = res.data
        this.index = (this.currentPage - 1) * this.pageSize + 1
        this.$emit('loaded')
      })
    },
    handleSort ({column, prop, order}) {
      this.sort = order === 'ascending' ? prop : ('-' + prop)
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    normalRegexpSearch(text) {
      if (text) {
        return text.replace(/\s+/g, '').split('').join(' ?')
      }
      return null
    },
    tableRowClassName({row, rowIndex}) {
      if (this.selection) {
        if (typeof this.selection === 'number') {
          if (row.id === this.selection) {
            return 'checked-row'
          }
        } else if(Array.isArray(this.selection)) {
          if (this.selection.includes(row.id)) {
            return 'checked-row'
          }
        }
      }
      return ''
    }
  }
}
</script>